module.exports = "/_next/static/images/img-hiring-faces-right-2492557e10b39c112eed02d8bb48a9a9.png";